// Company Configuration
export const COMPANY_CONFIG = {
  name: 'Zobox Protech Limited',
  tagline: "Let's do it...",
  branches: [
    {
      name: 'Corporate Branch',
      address: [
        'E218C, Sector 63',
        'Noida, Uttar Pradesh - 201309'
      ],
      mapUrl: 'https://share.google/mCzekOyBRVXzBkFNz'
    },
    {
      name: 'Registered Office',
      address: [
        '4th Floor, 6/77, Block 6, WEA',
        'Karol Bagh, New Delhi, Delhi - 110005'
      ],
      mapUrl: 'https://share.google/9ubXV4C3X8iXSE4Gg'
    }
  ],
  phone: '+91 9599900999',
  email: 'hr@zobox.in',
  website: 'zobox.in'
};

// Date and Currency Configuration
export const LOCALE_CONFIG = {
  dateFormat: 'DD/MM/YYYY',
  currency: '₹',
  locale: 'en-IN'
};

// Theme Configuration
export const THEME_CONFIG = {
  default: 'light',
  options: ['light', 'dark']
};

// Color Palette
export const COLORS = {
  primary: '#2b3380',
  primaryLight: '#3d4aa3',
  primaryDark: '#1f2661',
  secondary: '#5c6bc0',
  accent: '#7e57c2',
  success: '#4caf50',
  warning: '#ff9800',
  error: '#f44336',
  info: '#2196f3',
  background: '#f5f7fa',
  surface: '#ffffff',
  text: '#2c3e50',
  textSecondary: '#546e7a',
  sidebar: '#1a1f3a'
};
